import { createMiddleware } from '@shared/redux';
import { CAMPAIGN_TABLE_NOTIFICATIONS } from '@domain/segments';
import { showErrorToast } from '@shared/toasts/toasts.state';
import { GET_CAMPAIGNS_TAGS_BY_TYPE_REQUEST_FAIL } from './tags.state';

export const tagsMiddleware = createMiddleware({
    [GET_CAMPAIGNS_TAGS_BY_TYPE_REQUEST_FAIL]: () => showErrorToast(
        { message: CAMPAIGN_TABLE_NOTIFICATIONS.LOAD_TAGS_GROUP.ERROR },
    ),
});
